import { useEffect, useMemo, useRef, useState } from 'react'
import { getProjectRulesBatch } from '../../../../infrastructure/api/project-rules'
import { ProjectRulesResponse } from '../../../../domain/value-object/ProjectRulesVO'
import { featureFlagService } from '../../../../utils/feature-flag'
import { MyWbsItemRow } from '../myWbsItems'

const EMPTY_MAP = new Map<string, ProjectRulesResponse>()

export const useProjectRulesMap = (
  rows: MyWbsItemRow[]
): Map<string, ProjectRulesResponse> => {
  const [rulesMap, setRulesMap] =
    useState<Map<string, ProjectRulesResponse>>(EMPTY_MAP)
  const prevUuidsRef = useRef<string>('')

  const projectUuids = useMemo(() => {
    const uuids = new Set<string>()
    rows.forEach(row => {
      const uuid = row.body?.wbsItem?.projectUuid
      if (uuid) uuids.add(uuid)
    })
    return Array.from(uuids).sort()
  }, [rows])

  useEffect(() => {
    if (!featureFlagService.isEnabled('sprints-multi-select')) return
    if (projectUuids.length === 0) return

    const key = projectUuids.join(',')
    if (key === prevUuidsRef.current) return
    prevUuidsRef.current = key

    getProjectRulesBatch(projectUuids)
      .then(response => {
        const map = new Map<string, ProjectRulesResponse>()
        Object.entries(response.rules ?? {}).forEach(([uuid, rules]) => {
          map.set(uuid, rules)
        })
        setRulesMap(map)
      })
      .catch(() => {
        // API未実装時はデフォルト（MULTIPLE）のまま
      })
  }, [projectUuids])

  return rulesMap
}
